import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'big-ui-tag',
    templateUrl: './tag.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': '"inline-block text-sm leading-[1.6] px-3 rounded-lg bg-primary-200 text-primary-800 " + classList()',
    },
})
export class TagComponent {
    public readonly classList = input<string>('');
}
